import { render, staticRenderFns } from "./SortButtonGroup.vue?vue&type=template&id=972e0444&scoped=true"
import script from "./SortButtonGroup.vue?vue&type=script&lang=js"
export * from "./SortButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./SortButtonGroup.vue?vue&type=style&index=0&id=972e0444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e0444",
  null
  
)

export default component.exports